interface PricingHeroProps {
  billingCycle: "monthly" | "annual";
  setBillingCycle: (cycle: "monthly" | "annual") => void;
}

export default function PricingHero({ billingCycle, setBillingCycle }: PricingHeroProps) {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628] via-[#0D1F3C] to-[#0A1628]"></div>
      
      {/* Grid overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: 'linear-gradient(#00FFD1 1px, transparent 1px), linear-gradient(90deg, #00FFD1 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-[#00FFD1]/10 border border-[#00FFD1]/30 rounded-full px-5 py-2 mb-8">
          <i className="ri-price-tag-3-line text-[#00FFD1] text-sm"></i>
          <span className="text-[#00FFD1] text-sm font-medium uppercase tracking-widest">Simple, transparent pricing</span>
        </div>

        <h1 className="text-6xl font-bold mb-6 leading-tight">
          Choose your flight plan
        </h1>
        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto">
          From student pilots to seasoned instructors — WingmanFix scales with your aviation journey. Start free, upgrade anytime.
        </p>

        {/* Billing toggle */}
        <div className="inline-flex items-center gap-4 bg-white/5 backdrop-blur-sm border border-white/10 rounded-full p-2">
          <button
            onClick={() => setBillingCycle("monthly")}
            className={`px-8 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              billingCycle === "monthly"
                ? "bg-[#00A3E0] text-white shadow-lg"
                : "text-gray-400 hover:text-white"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => setBillingCycle("annual")}
            className={`px-8 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
              billingCycle === "annual"
                ? "bg-[#00A3E0] text-white shadow-lg"
                : "text-gray-400 hover:text-white"
            }`}
          >
            Annual
            <span className="bg-[#00FFD1] text-[#0A1628] text-xs font-bold px-2 py-1 rounded-full">
              Save 20%
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}